/**
 * What the active Mojo Up AI Cloud organisation may do, for the views that change with it (JP, 22 Oct 2026): a
 * person's own space is an account (sign-in, workbench licence and updates, downloads), and a team works only on
 * Teams. The API enforces it (packages/api/src/cloud/freeTier.ts answers a write 402 `teams_required`); the console
 * reads the same plan so a free account is never shown a workspace it cannot use.
 *
 * Enterprise is licensed as a whole, so every answer there is "everything".
 */

import { useCloud } from './auth/AuthProvider.tsx';
import { isCloud } from './edition.ts';

export interface CloudStanding {
  /** Mojo Up AI Cloud at all. */
  cloud: boolean;
  /** A person's own space: the account, never a workspace. */
  personal: boolean;
  /** The organisation has Teams (a trial counts): every Teams view works. */
  teams: boolean;
  /** The person may start a trial or buy Teams for this organisation. */
  mayBuy: boolean;
}

const EVERYTHING: CloudStanding = { cloud: false, personal: false, teams: true, mayBuy: false };

/** The active organisation's standing; outside Cloud, everything. */
export function useCloudStanding(): CloudStanding {
  const cloud = useCloud();
  if (!isCloud() || !cloud) return EVERYTHING;
  const o = cloud.organisation;
  const personal = o.kind === 'personal';
  return { cloud: true, personal, teams: !personal && o.plan === 'teams', mayBuy: !personal && o.role === 'owner' };
}
